export const AdSlot = ({ id, label = "Publicidade", height = "min-h-[96px] sm:min-h-[110px]", className = "" }) => (
  <aside
    data-testid={`ad-slot-${id}`}
    aria-label="Espaço publicitário"
    className={`mx-auto w-full max-w-5xl px-5 ${className}`}
  >
    <div className="flex items-center gap-3 pb-2">
      <span className="text-[10px] uppercase tracking-[0.28em] text-neutral-400">
        {label}
      </span>
      <span className="h-px flex-1 bg-neutral-200" />
    </div>
    <div
      className={`flex items-center justify-center rounded-xl border border-dashed border-neutral-200 bg-[#f6f6f5] ${height}`}
    >
      <ins
        className="adsbygoogle block h-full w-full"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  </aside>
);
